<div class="flex flex-col gap-3">
  <div class="text-general-title">
    <div class="text-(--color-text-primary)">
      {{ 'quotation.fieldNames.messageSystem' | translate }}
    </div>
  </div>

  <div class="text-general text-center">
    <div>{{ message }}</div>
  </div>

  <div class="flex justify-center gap-3">
    <button matButton="filled" class="button-general-light" (click)="closeModal()">
      {{ 'general.acept' | translate }}
    </button>
  </div>
</div>
